// src/store.ts

import { configureStore } from '@reduxjs/toolkit';
import TrackingReducer from './slice/TrackingSlice'
import UpdateTrackingAddressSlice from './slice/UpdateTrackingAddressSlice';
import { useDispatch, useSelector } from 'react-redux';
const AppStore = configureStore({
  reducer: {
    tracking: TrackingReducer,
   updateAddress: UpdateTrackingAddressSlice,
  },
});

export type RootState = ReturnType<typeof AppStore.getState>;
export type AppDispatch = typeof AppStore.dispatch;
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()
export default AppStore;
